<template lang="pug">
	.campaign-creatives-list.flex-col.space
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns")
			template(v-slot:name-cell-template="{ data }")
				.flex-row.space.align-center
					DxButton(v-if="!readonly", icon="fas fa-times", stylingMode="text", @click="unlinkCreative(data.Oid)", :hint="$tCaption('Unlink creative')")
					span {{data.Name}}
					DxDropDownButton(v-if="getActions(data).length", icon="more", :items="getActions(data)", stylingMode="text",  display-expr="name", key-expr="id", 	
						:use-select-mode="false", :showArrowIcon="false", :drop-down-options="{ width: 230 }", @item-click="e => onActionClick(e, data)")
			template(v-if="!readonly", slot="left-actions")
				.flex-row.space.align-center
					Dropdown(ref="creativeSelector",
						v-model="linkCreative",
						:multiple="false",
						:getData="(a,b,c) => $Data.getAllCreatives(a,b, { ...(c || {}), onlyPublished: true })",
						:searchVisible="true",
						:dropDownOptions="{ width: '560px' }",
						:getItems="r => r.Results",
						:filtersVisible="false",
						:columns="[{ dataField: 'Name', caption: () => $tCaption('Name') }, { dataField: 'DisplayLength', caption: () => $tCaption('Length (sec)'), width: 100 }, { dataField: 'ISCI', caption: () => $tCaption('ISCI'), width: 120 }]",
						:placeholder="$tCaption('Add creative')",
						valueExpr="Oid",
						displayExpr="Name")
		CreativeVastLink(ref="vastLink")
</template>

<script>
	import {DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem} from 'devextreme-vue/data-grid';
	import Pager from 'app-core/Pager.vue';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import CreativeVastLink from 'view/creative/CreativeVastLink.vue';

	export default {
		translationCategory: 'campaign.CampaignCreatives',
		name: 'creatives-list',
		components: {
			DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem, Pager, DxButton, ListView, Dropdown, DxDropDownButton, CreativeVastLink
		},
		props: ['campaignId', 'readonly'],
		data() {
			return {
				currentPage: 0,
				creatives: {},
				bottomPlayer: {
					isInitiated: false,
					playState: false,
					audioLink: null,
					fileName: null,
					title: null,
					duration: null,
					fieldName: null
				},
				columns: [
					{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'name-cell-template'  },
					{ dataField: 'Isci', caption: () => this.$tCaption('ISCI') },
					{ dataField: 'DisplayLength', caption: () => this.$tCaption('Length (sec)'), dataType: 'number' },
					{ dataField: 'Trimmed', caption: () => this.$tCaption('Trimmed'), dataType: 'boolean' },
					{ dataField: 'Normalized', caption: () => this.$tCaption('Normalized'), dataType: 'boolean' },
					{ dataField: 'IsPublished', caption: () => this.$tCaption('Published'), dataType: 'boolean' }
				],
				linkCreative: null,
				actions: [
					{ id: 'vast', name: this.$tCaption('Get VAST Tag'), icon: 'fas fa-copy', hidden: (c) => !c.IsPublished },
				]
			};
		},
		computed: {
			grid() {
				return this.$refs.grid && this.$refs.grid.instance;
			}
		},
		watch: {
			linkCreative(v) {
				if (v)
					this.doLinkCreative();
			}
		},
		methods: {
			getActions(creative) {
				return this.actions.filter(f => !f.hidden || !f.hidden(creative));
			},
			onActionClick(e, creative) {
				switch(e.itemData.id) {
					case 'vast':
						this.$refs.vastLink.open(creative.Oid, { params: `campaignId=${this.campaignId}` });
						break;
				}
			},
			doLinkCreative() {
				if (this.linkCreative) {
					var creativeId = this.linkCreative;
					this.linkCreative = null;
					this.$refs.creativeSelector.clear();
					this.$Data.getExternalApi('Campaign/AddCreativesToCampaign', `campaignId=${this.campaignId}&creativeIds=${creativeId}`).then(r => {
						if (r.Success) {
							this.$refs.listView.reload();
							this.$notifySuccess(this.$tCaption('Creative linked with campaign'));
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					});
				}
			},
			unlinkCreative(creativeId) {
				this.$confirmMessage({
					title: () => this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to unlink creative?'),
					handler: () => {
						this.$Data.getExternalApi('Campaign/RemoveCreativesFromCampaign', `campaignId=${this.campaignId}&creativeIds=${creativeId}`).then(r => {
							if (r.Success) {
								this.$refs.listView.reload();
								this.$notifySuccess(this.$tCaption('Creative unlikned with campaign'));
							} else {
								this.$notifyError(r.ErrorMessage);
							}
						});
					}
				});
			},
			editAudio(record, isNew) {
				this.$router.push({ path: `/creative/Detail/${record.Oid}`, params: { isNew } });
			},
			loadData(pageIndex, limit, opts) {
				return this.$Data.getExternalCampaignCreatives(pageIndex, limit, opts, this.campaignId);
			}
		}
	};
</script>
<style lang='scss'>
	.campaign-creatives-list {
	}
</style>
